import React, { createContext, useContext } from 'react';
export const ModulosContext = createContext();

export const ModulosProvider = ({ children }) => {

    const modulosPorDefecto = 'Inicio,Mis-reportes,Crear-reporte-servicios-publicos';

    const modulos = 'Inicio,Usuarios,Todos-los-reportes,Mis-reportes,Crear-reporte-emergencias,Crear-reporte-servicios-publicos';

    return (
        <ModulosContext.Provider value={{ modulosPorDefecto, modulos }}>
            {children}
        </ModulosContext.Provider>
    );
};

// Crear un hook personalizado para acceder al contexto
export const useModulos = () => {
    return useContext(ModulosContext);
};
